<script>
import axios from "axios";
import Swal from "sweetalert2";
//import vue2Dropzone from "vue2-dropzone";
import Multiselect from "vue-multiselect";
import { required, email, minValue, maxValue } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
//import { isValidDate } from '@fullcalendar/common';

/**
 * Add-product component
 */
export default {
  page: {
    title: "Edit Employee",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    //vueDropzone: vue2Dropzone,
    Multiselect,
    Layout,
    PageHeader,
    DatePicker,
  },
  data() {
    return {
      title: "Edit Employee",
      loginData: {},
      emp : {},
      employeeTest: {},
      employee: {
        empId: 0,
        empIdInCompany: "",
        companyId: "",
        teamId: 0,
        name: "",
        designation: "",
        email: "",
        alternateEmail: "",
        phone: "",
        gender: "",
        dob: "",
        totalLeave: "",
        location: "",
        country: "",
        timezone: "",
        immediateHead: "",
        linkedInUrl: "",
        projects: [],
        shiftStartTime: 0,
        shiftEndTime: 0,
        workingDays: "",
        jobType: "",
        joiningDate: "",
        leavingDate: "",
        reasonOfLeave: "",
        remarks: "",
        addedTime: "",
        lastModifiedTime: "",
        status: "",
        isDeleted: "",
      },
      isInvalidShift: false,
      longDob : "",
      longJoiningDate: "",
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        acceptedFiles: "image/*",
        method: "POST",
        thumbnailHeight: 100,
        accept: (file) => {
          this.onAccept(file);
        },
      },
      value: null,
      value1: null,
      product: {
        name: "",
        manufacture_name: "",
        manufacture_brand: "",
        price: null,
      },
      formData: new FormData(),
      submitted: false,
      genderOptions: [
        {
          text: "Female",
          value: 1
        },
        {
          text: "Male",
          value: 2
        },
        {
          text: "Prefer Not to Say",
          value: 3
        },
        {
          text: "Others",
          value: 4
        }
      ],
      teamOptions: [
        {
          value: 1000000,
          text: "DEFAULT",
        }
      ],
      ruleOptions: [
        {
          value: 1000000,
          text: "DEFAULT",
        }
      ],
      projectOptions: [
      ],
      countryOptions: [
        { text: "Andorra", value: "Europe/Andorra"},
        { text: "United Arab Emirates", value: "Asia/Dubai"},
        { text: "Afghanistan", value: "Asia/Kabul"},
        { text: "Antigua and Barbuda", value: "America/Antigua"},
        { text: "Anguilla", value: "America/Anguilla"},
        { text: "Albania", value: "Europe/Tirane"},
        { text: "Armenia", value: "Asia/Yerevan"},
        { text: "Netherlands Antilles", value: "Europe/Amsterdam"},
        { text: "Angola", value: "Africa/Luanda"},
        { text: "Antarctica", value: "Antarctica/Casey"},
        { text: "Argentina", value: "America/Argentina/Buenos_Aires", list: [
                {text: "America/Argentina/Buenos_Aires", value: "UTC -03:53"},
                {text: "America/Argentina/Catamarca", value: "UTC -04:23"},
                {text: "America/Argentina/Cordoba", value: "UTC -04:16"},
                {text: "America/Argentina/Jujuy", value: "UTC -04:21"},
                {text: "America/Argentina/La_Rioja", value: "UTC -04:27"},
                {text: "America/Argentina/Mendoza", value: "UTC -04:35"},
                {text: "America/Argentina/Rio_Gallegos", value: "UTC -04:36"},
                {text: "America/Argentina/Salta", value: "UTC -04:21"},
                {text: "America/Argentina/San_Juan", value: "UTC -04:34"},
                {text: "America/Argentina/San_Luis", value: "UTC -04:25"},
                {text: "America/Argentina/Tucuman", value: "UTC -04:20"},
                {text: "America/Argentina/Ushuaia,", value: "UTC -04:33"}
                ]
        },
        { text: "American Samoa", value: "Pacific/Pago_Pago"},
        { text: "Austria", value: "Europe/Vienna"},
        { text: "Australia", value: "Australia/Sydney", list: [
                {
                        text: "Antarctica/Macquarie",
                        value: "UTC"
                },
                {
                        text: "Australia/Adelaide",
                        value: "UTC +09:14"
                },
                {
                        text: "Australia/Brisbane",
                        value: "UTC +10:12"
                },
                {
                        text: "Australia/Broken_Hill",
                        value: "UTC +09:25"
                },
                {
                        text: "Australia/Darwin",
                        value: "UTC +08:43"
                },
                {
                        text: "Australia/Eucla",
                        value: "UTC +08:35"
                },
                {
                        text: "Australia/Hobart",
                        value: "UTC +09:49"
                },
                {
                        text: "Australia/Lindeman",
                        value: "UTC +09:55"
                },
                {
                        text: "Australia/Lord_Howe",
                        value: "UTC +10:36"
                },
                {
                        text: "Australia/Melbourne",
                        value: "UTC +09:39"
                },
                {
                        text: "Australia/Perth",
                        value: "UTC +07:43"
                },
                {
                        text: "Australia/Sydney",
                        value: "UTC +10:04"
                }
                ]},
        { text: "Aruba", value: "America/Aruba"},
        { text: "Åland Islands", value: "Europe/Mariehamn"},
        { text: "Azerbaijan", value: "Asia/Baku"},
        { text: "Bosnia and Herzegovina", value: "Europe/Sarajevo"},
        { text: "Barbados", value: "America/Barbados"},
        { text: "Bangladesh", value: "Asia/Dhaka"},
        { text: "Belgium", value: "Europe/Brussels"},
        { text: "Burkina Faso", value: "Africa/Ouagadougou"},
        { text: "Bulgaria", value: "Europe/Sofia"},
        { text: "Bahrain", value: "Asia/Bahrain"},
        { text: "Burundi", value: "Africa/Bujumbura"},
        { text: "Benin", value: "Africa/Porto-Novo"},
        { text: "Saint Barthélemy", value: "America/St_Barthelemy"},
        { text: "Bermuda", value: "Atlantic/Bermuda"},
        { text: "Brunei", value: "Asia/Brunei"},
        { text: "Bolivia", value: "America/La_Paz"},
        { text: "Bonaire, Sint Eustatius and Saba", value: "America/Kralendijk" },
        { text: "Brazil", value: "America/Araguaina", list: 
                [
                {text: "America/Araguaina", value: "UTC -03:12"},
                {text: "America/Bahia", value: "UTC -02:34"},
                {text: "America/Belem", value: "UTC -03:13"},
                {text: "America/Boa_Vista", value: "UTC -04:02"},
                {text: "America/Campo_Grande", value: "UTC -03:38"},
                {text: "America/Cuiaba", value: "UTC -03:44"},
                {text: "America/Eirunepe", value: "UTC -04:39"},
                {text: "America/Fortaleza", value: "UTC -02:34"},
                {text: "America/Maceio", value: "UTC -02:22"},
                {text: "America/Manaus", value: "UTC -04:00"},
                {text: "America/Noronha", value: "UTC -02:09"},
                {text: "America/Porto_Velho", value: "UTC -04:15"},
                {text: "America/Recife", value: "UTC -02:19"},
                {text: "America/Rio_Branco", value: "UTC -04:31"},
                {text: "America/Santarem", value: "UTC -03:38"},
                {text: "America/Sao_Paulo", value: "UTC -03:06"}]},
        { text: "Bahamas", value: "America/Nassau"},
        { text: "Bhutan", value: "Asia/Thimphu"},
        { text: "Bouvet Island", value: "null"},
        { text: "Botswana", value: "Africa/Gaborone"},
        { text: "Belarus", value: "Europe/Minsk"},
        { text: "Belize", value: "America/Belize"},
        { text: "Canada", value: "America/Atikokan", list: 
                [{text: "America/Atikokan", value: "UTC -05:18"},
                {text: "America/Blanc-Sablon", value: "UTC -04:24"},
                {text: "America/Cambridge_Bay", value: "UTC"},
                {text: "America/Creston", value: "UTC -07:28"},
                {text: "America/Dawson", value: "UTC -09:17"},
                {text: "America/Dawson_Creek", value: "UTC -08:00"},
                {text: "America/Edmonton", value: "UTC -07:33"},
                {text: "America/Fort_Nelson", value: "UTC -08:10"},
                {text: "America/Glace_Bay", value: "UTC -03:59"},
                {text: "America/Goose_Bay", value: "UTC -04:01"},
                {text: "America/Halifax", value: "UTC -04:14"},
                {text: "America/Inuvik", value: "UTC"},
                {text: "America/Iqaluit", value: "UTC"},
                {text: "America/Moncton", value: "UTC -04:19"},
                {text: "America/Nipigon", value: "UTC -05:53"},
                {text: "America/Pangnirtung", value: "UTC"},
                {text: "America/Rainy_River", value: "UTC -06:18"},
                {text: "America/Rankin_Inlet", value: "UTC"},
                {text: "America/Regina", value: "UTC -06:58"},
                {text: "America/Resolute", value: "UTC"},
                {text: "America/St_Johns", value: "UTC -03:30"},
                {text: "America/Swift_Current", value: "UTC -07:11"},
                {text: "America/Thunder_Bay", value: "UTC -05:57"},
                {text: "America/Toronto", value: "UTC -05:17"},
                {text: "America/Vancouver", value: "UTC -08:12"},
                {text: "America/Whitehorse", value: "UTC -09:00"},
                {text: "America/Winnipeg", value: "UTC -06:28"},
                {text: "America/Yellowknife", value: "UTC"}]},
        { text: "Cocos Islands", value: "Indian/Cocos"},
        { text: "The Democratic Republic Of Congo", value: "Africa/Kinshasa", list:
                [
                {text: "Africa/Kinshasa", value: "UTC +00:13"},
                {text: "Africa/Lubumbashi", value: "UTC +02:10"}
                ]},
        { text: "Central African Republic", value: "Africa/Bangui"},
        { text: "Congo", value: "Africa/Kinshasa"},
        { text: "Switzerland", value: "Europe/Zurich"},
        { text: "Côte d'Ivoire", value: "Africa/Abidjan"},
        { text: "Cook Islands", value: "Pacific/Rarotonga"},
        { text: "Chile", value: "America/Punta_Arenas", list:
                [
                {text: "America/Punta_Arenas", value: "UTC -04:43"},
                {text: "America/Santiago", value: "UTC -04:42"},
                {text: "Pacific/Easter", value: "UTC -07:17"},
                ]},
        { text: "Cameroon", value: "Africa/Douala"},
        { text: "China", value: "Asia/Shanghai", list:
                [
                {text: "Asia/Shanghai", value: "UTC +08:05"},
                {text: "Asia/Urumqi", value: "UTC +05:50"}
                ]},
        { text: "Colombia", value: "America/Bogota"},
        { text: "Costa Rica", value: "America/Costa_Rica"},
        { text: "Cuba", value: "America/Havana"},
        { text: "Cape Verde", value: "Atlantic/Cape_Verde"},
        { text: "Curaçao", value: "America/Curacao"},
        { text: "Christmas Island", value: "Indian/Christmas"},
        { text: "Cyprus", value: "Asia/Famagusta", list:
                [
                {text: "Asia/Famagusta", value: "UTC +02:15"},
                {text: "Asia/Nicosia", value: "UTC +02:13"}
                ]},
        { text: "Czech Republic", value: "Europe/Prague"},
        { text: "Germany", value: "Europe/Copenhagen"},
        { text: "Djibouti", value: "Africa/Djibouti"},
        { text: "Denmark", value: "Europe/Copenhagen"},
        { text: "Dominica", value: "America/Dominica"},
        { text: "Dominican Republic", value: "America/Santo_Domingo"},
        { text: "Algeria", value: "Africa/Algiers"},
        { text: "Ecuador", value: "America/Guayaquil", list:
                [
                {text: "America/Guayaquil", value: "UTC -05:19"},
                {text: "Pacific/Galapagos", value: "UTC -05:58"}
                ]},
        { text: "Estonia", value: "Europe/Tallinn"},
        { text: "Egypt", value: "Africa/Cairo"},
        { text: "Western Sahara", value: "Africa/El_Aaiun"},
        { text: "Eritrea", value: "Africa/Asmara"},
        { text: "Spain", value: "Europe/Madrid", list:
                [
                {text: "Africa/Ceuta", value: "UTC -00:21"},
                {text: "Atlantic/Canary", value: "UTC -01:01"},
                {text: "Europe/Madrid", value: "UTC -00:14"},
                ]},
        { text: "Ethiopia", value: "Africa/Addis_Ababa"},
        { text: "Finland", value: "Europe/Helsinki"},
        { text: "Fiji", value: "Pacific/Fiji"},
        { text: "Falkland Islands", value: "Atlantic/Stanley"},
        { text: "Micronesia", value: "Pacific/Chuuk", list:
                [
                {text: "Pacific/Chuuk", value: "UTC -13:52"},
                {text: "Pacific/Kosrae", value: "UTC -13:08"},
                {text: "Pacific/Pohnpei", value: "UTC -13:27"},
                ]},
        { text: "Faroe Islands", value: "Atlantic/Faroe"},
        { text: "France", value: "Europe/Paris"},
        { text: "Gabon", value: "Africa/Libreville"},
        { text: "United Kingdom", value: "Europe/London"},
        { text: "Grenada", value: "America/Grenada"},
        { text: "Georgia", value: "Asia/Tbilisi"},
        { text: "French Guiana", value: "America/Cayenne"},
        { text: "Guernsey", value: "Europe/Guernsey"},
        { text: "Ghana", value: "Africa/Accra"},
        { text: "Gibraltar", value: "Europe/Gibraltar"},
        { text: "Greenland", value: "America/Danmarkshavn", list:
                [
                {text: "America/Danmarkshavn", value: "UTC -01:14"},
                {text: "America/Nuuk", value: "UTC -03:26"},
                {text: "America/Scoresbysund", value: "UTC -01:27"},
                {text: "America/Thule", value: "UTC -04:35"},
                ]},
        { text: "Gambia", value: "Africa/Banjul"},
        { text: "Guinea", value: "Africa/Conakry"},
        { text: "Guadeloupe", value: "America/Guadeloupe"},
        { text: "Equatorial Guinea", value: "Africa/Malabo"},
        { text: "Greece", value: "Europe/Athens"},
        { text: "South Georgia And The South Sandwich Islands", value: "Atlantic/South_Georgia"},
        { text: "Guatemala", value: "America/Guatemala"},
        { text: "Guam", value: "Pacific/Guam"},
        { text: "Guinea-Bissau", value: "Africa/Bissau"},
        { text: "Guyana", value: "America/Guyana"},
        { text: "Hong Kong", value: "Asia/Hong_Kong"},
        { text: "Heard Island And McDonald Islands", value: "No/Timezone"},
        { text: "Honduras", value: "America/Tegucigalpa"},
        { text: "Croatia", value: "Europe/Zagreb"},
        { text: "Haiti", value: "America/Port-au-Prince"},
        { text: "Hungary", value: "Europe/Budapest"},
        { text: "Indonesia", value: "Asia/Jakarta", list:
                [
                {text: "Asia/Jakarta", value: "UTC +07:07"},
                {text: "Asia/Jayapura", value: "UTC +09:22"},
                {text: "Asia/Makassar", value: "UTC +07:57"},
                {text: "Asia/Pontianak", value: "UTC +07:17"},
                ]},
        { text: "Ireland", value: "Europe/Dublin"},
        { text: "Israel", value: "Asia/Jerusalem"},
        { text: "Isle Of Man", value: "Europe/Isle_of_Man"},
        { text: "India", value: "Asia/Kolkata"},
        { text: "British Indian Ocean Territory", value: "Indian/Chagos"},
        { text: "Iraq", value: "Asia/Baghdad"},
        { text: "Iran", value: "Asia/Tehran"},
        { text: "Iceland", value: "Atlantic/Reykjavik"},
        { text: "Italy", value: "Europe/Rome"},
        { text: "Jersey", value: "Europe/Jersey"},
        { text: "Jamaica", value: "America/Jamaica"},
        { text: "Jordan", value: "Asia/Amman"},
        { text: "Japan", value: "Asia/Tokyo"},
        { text: "Kenya", value: "Africa/Nairobi"},
        { text: "Kyrgyzstan", value: "Asia/Bishkek"},
        { text: "Cambodia", value: "Asia/Phnom_Penh"},
        { text: "Kiribati", value: "Pacific/Kanton", list:
                [
                {text: "Pacific/Kanton", value: "UTC"},
                {text: "Pacific/Kiritimati", value: "UTC -10:29"},
                {text: "Pacific/Tarawa", value: "UTC +11:32"},
                ]},
        { text: "Comoros", value: "Indian/Comoro"},
        { text: "Saint Kitts And Nevis", value: "America/St_Kitts"},
        { text: "North Korea", value: "Asia/Pyongyang"},
        { text: "South Korea", value: "Asia/Seoul"},
        { text: "Kuwait", value: "Asia/Kuwait"},
        { text: "Cayman Islands", value: "America/Cayman"},
        { text: "Kazakhstan", value: "Asia/Almaty", list:
                [
                {text: "Asia/Almaty", value: "UTC +05:07"},
                {text: "Asia/Aqtau", value: "UTC +03:21"},
                {text: "Asia/Aqtobe", value: "UTC +03:48"},
                {text: "Asia/Atyrau", value: "UTC +03:27"},
                {text: "Asia/Oral", value: "UTC +03:25"},
                {text: "Asia/Qostanay", value: "UTC +04:14"},
                {text: "Asia/Qyzylorda", value: "UTC +04:21"},
                ]},
        { text: "Laos", value: "Asia/Vientiane"},
        { text: "Lebanon", value: "Asia/Beirut"},
        { text: "Saint Lucia", value: "America/St_Lucia"},
        { text: "Liechtenstein", value: "Europe/Vaduz"},
        { text: "Sri Lanka", value: "Asia/Colombo"},
        { text: "Liberia", value: "Africa/Monrovia"},
        { text: "Lesotho", value: "Africa/Maseru"},
        { text: "Lithuania", value: "Europe/Vilnius"},
        { text: "Luxembourg", value: "Europe/Luxembourg"},
        { text: "Latvia", value: "Europe/Riga"},
        { text: "Libya", value: "Africa/Tripoli"},
        { text: "Morocco", value: "Africa/Casablanca"},
        { text: "Monaco", value: "Europe/Monaco"},
        { text: "Moldova", value: "Europe/Chisinau"},
        { text: "Montenegro", value: "Europe/Podgorica"},
        { text: "Saint Martin", value: "America/Marigot"},
        { text: "Madagascar", value: "Indian/Antananarivo"},
        { text: "Marshall Islands", value: "Pacific/Kwajalein", list:
                [
                {text: "Pacific/Kwajalein", value: "UTC +11:09"},
                {text: "Pacific/Majuro", value: "UTC +11:24"},
                ]},
        { text: "Macedonia", value: "Europe/Skopje"},
        { text: "Mali", value: "Africa/Bamako"},
        { text: "Myanmar", value: "Asia/Yangon"},
        { text: "Mongolia", value: "Asia/Ulaanbaatar", list:
                [
                {text: "Asia/Choibalsan", value: "UTC +07:38"},
                {text: "Asia/Hovd", value: "UTC +06:06"},
                {text: "Asia/Ulaanbaatar", value: "UTC +07:07"},
                ]},
        { text: "Macao", value: "Asia/Macau"},
        { text: "Northern Mariana Islands", value: "Pacific/Saipan"},
        { text: "Martinique", value: "America/Martinique"},
        { text: "Mauritania", value: "Africa/Nouakchott"},
        { text: "Montserrat", value: "America/Montserrat"},
        { text: "Malta", value: "Europe/Malta"},
        { text: "Mauritius", value: "Indian/Mauritius"},
        { text: "Maldives", value: "Indian/Maldives"},
        { text: "Malawi", value: "Africa/Blantyre"},
        { text: "Mexico", value: "America/Mexico_City", list:
                [
                {text: "America/Bahia_Banderas", value: "UTC -07:01"},
                {text: "America/Cancun", value: "UTC -05:47"},
                {text: "America/Chihuahua", value: "UTC -07:04"},
                {text: "America/Hermosillo", value: "UTC -07:23"},
                {text: "America/Matamoros", value: "UTC -06:40"},
                {text: "America/Mazatlan", value: "UTC -07:05"},
                {text: "America/Merida", value: "UTC -05:58"},
                {text: "America/Mexico_City", value: "UTC -06:36"},
                {text: "America/Monterrey", value: "UTC -06:41"},
                {text: "America/Ojinaga", value: "UTC -06:57"},
                {text: "America/Tijuana", value: "UTC -07:48"},
                ]},
        { text: "Malaysia", value: "Asia/Kuala_Lumpur", list:
                [
                {text: "Asia/Kuala_Lumpur", value: "UTC +06:46"},
                {text: "Asia/Kuching", value: "UTC +07:21"},
                ]},
        { text: "Mozambique", value: "Africa/Maputo"},
        { text: "Namibia", value: "Africa/Windhoek"},
        { text: "New Caledonia", value: "Pacific/Noumea"},
        { text: "Niger", value: "Africa/Niamey"},
        { text: "Norfolk Island", value: "Pacific/Norfolk"},
        { text: "Nigeria", value: "Africa/Lagos"},
        { text: "Nicaragua", value: "America/Managua"},
        { text: "Netherlands", value: "Europe/Amsterdam"},
        { text: "Norway", value: "AEurope/Oslo"},
        { text: "Nepal", value: "Asia/Kathmandu"},
        { text: "Nauru", value: "Pacific/Nauru"},
        { text: "Niue", value: "Pacific/Niue"},
        { text: "New Zealand", value: "Pacific/Auckland", list:
                [
                {text: "Pacific/Auckland", value: "UTC +11:39"},
                {text: "Pacific/Chatham", value: "UTC +12:13"},
                ]},
        { text: "Oman", value: "Asia/Muscat"},
        { text: "Panama", value: "America/Panama"},
        { text: "Peru", value: "America/Lima"},
        { text: "French Polynesia", value: "Pacific/Gambier", list:
                [
                {text: "Pacific/Gambier", value: "UTC -08:59"},
                {text: "Pacific/Marquesas", value: "UTC -09:18"},
                {text: "Pacific/Tahiti", value: "UTC -09:58"},
                ]},
        { text: "Papua New Guinea", value: "Pacific/Bougainville", list:
                [
                {text: "Pacific/Bougainville", value: "UTC +10:22"},
                {text: "Pacific/Port_Moresby", value: "UTC +09:48"},
                ]},
        { text: "Philippines", value: "Asia/Manila"},
        { text: "Pakistan", value: "Asia/Karachi"},
        { text: "Poland", value: "Europe/Warsaw"},
        { text: "Saint Pierre And Miquelon", value: "America/Miquelon"},
        { text: "Pitcairn", value: "Pacific/Pitcairn"},
        { text: "Puerto Rico", value: "America/Puerto_Rico"},
        { text: "Palestine", value: "Asia/Gaza", list:
                [
                {text: "Asia/Gaza", value: "UTC +02:17"},
                {text: "Asia/Hebron", value: "UTC +02:20"},
                ]},
        { text: "Portugal", value: "Europe/Lisbon", list:
                [
                {text: "Atlantic/Azores", value: "UTC -01:42"},
                {text: "Atlantic/Madeira", value: "UTC -01:07"},
                {text: "Europe/Lisbon", value: "UTC -00:36"},
                ]},
        { text: "Palau", value: "Pacific/Palau"},
        { text: "Paraguay", value: "America/Asuncion"},
        { text: "Qatar", value: "Asia/Qatar"},
        { text: "Reunion", value: "Indian/Reunion"},
        { text: "Romania", value: "Europe/Bucharest"},
        { text: "Serbia", value: "Europe/Belgrade"},
        { text: "Russia", value: "Europe/Moscow", list:
                [
                {text: "Asia/Anadyr", value: "UTC +11:49"},
                {text: "Asia/Barnaul", value: "UTC +05:35"},
                {text: "Asia/Chita", value: "UTC +07:33"},
                {text: "Asia/Irkutsk", value: "UTC +06:57"},
                {text: "Asia/Kamchatka", value: "UTC +10:34"},
                {text: "Asia/Khandyga", value: "UTC +09:02"},
                {text: "Asia/Krasnoyarsk", value: "UTC +06:11"},
                {text: "Asia/Magadan", value: "UTC +10:03"},
                {text: "Asia/Novokuznetsk", value: "UTC +05:48"},
                {text: "Asia/Novosibirsk", value: "UTC +05:31"},
                {text: "Asia/Omsk", value: "UTC +04:53"},
                {text: "Asia/Sakhalin", value: "UTC +09:30"},
                {text: "Asia/Srednekolymsk", value: "UTC +10:14"},
                {text: "Asia/Tomsk", value: "UTC +05:39"},
                {text: "Asia/Ust-Nera", value: "UTC +09:32"},
                {text: "Asia/Vladivostok", value: "UTC +08:47"},
                {text: "Asia/Yakutsk", value: "UTC +08:38"},
                {text: "Asia/Yekaterinburg", value: "UTC +04:02"},
                {text: "Europe/Astrakhan", value: "UTC +03:12"},
                {text: "Europe/Kaliningrad", value: "UTC +01:22"},
                {text: "Europe/Kirov", value: "UTC +03:18"},
                {text: "Europe/Moscow", value: "UTC +02:30"},
                {text: "Europe/Samara", value: "UTC +03:20"},
                {text: "Europe/Saratov", value: "UTC +03:04"},
                {text: "Europe/Ulyanovsk", value: "UTC +03:13"},
                {text: "Europe/Volgograd", value: "UTC +02:57"},
                ]},
        { text: "Rwanda", value: "Africa/Kigali"},
        { text: "Saudi Arabia", value: "Asia/Riyadh"},
        { text: "Solomon Islands", value: "Pacific/Guadalcanal"},
        { text: "Seychelles", value: "Indian/Mahe"},
        { text: "Sudan", value: "Africa/Khartoum"},
        { text: "Sweden", value: "Europe/Stockholm"},
        { text: "Singapore", value: "Asia/Singapore"},
        { text: "Saint Helena", value: "Atlantic/St_Helena"},
        { text: "Slovenia", value: "Europe/Ljubljana"},
        { text: "Svalbard And Jan Mayen", value: "Arctic/Longyearbyen"},
        { text: "Slovakia", value: "Europe/Bratislava"},
        { text: "Sierra Leone", value: "Africa/Freetown"},
        { text: "San Marino", value: "Europe/San_Marino"},
        { text: "Senegal", value: "Africa/Dakar"},
        { text: "Somalia", value: "Africa/Mogadishu"},
        { text: "Suriname", value: "America/Paramaribo"},
        { text: "South Sudan", value: "Africa/Juba"},
        { text: "Sao Tome And Principe", value: "Africa/Sao_Tome"},
        { text: "El Salvador", value: "America/El_Salvador"},
        { text: "Sint Maarten (Dutch part)", value: "America/Lower_Princes"},
        { text: "Syria", value: "Asia/Damascus"},
        { text: "Swaziland", value: "Africa/Mbabane"},
        { text: "Turks And Caicos Islands", value: "America/Grand_Turk"},
        { text: "Chad", value: "Africa/Ndjamena"},
        { text: "French Southern Territories", value: "Indian/Kerguelen"},
        { text: "Togo", value: "Africa/Lome"},
        { text: "Thailand", value: "Asia/Bangkok"},
        { text: "Tajikistan", value: "Asia/Dushanbe"},
        { text: "Tokelau", value: "Pacific/Fakaofo"},
        { text: "Timor-Leste", value: "Asia/Dili"},
        { text: "Turkmenistan", value: "Asia/Ashgabat"},
        { text: "Tunisia", value: "Africa/Tunis"},
        { text: "Tonga", value: "Pacific/Tongatapu"},
        { text: "Turkey", value: "Europe/Istanbul"},
        { text: "Trinidad and Tobago", value: "America/Port_of_Spain"},
        { text: "Tuvalu", value: "Pacific/Funafuti"},
        { text: "Taiwan", value: "Asia/Taipei"},
        { text: "Tanzania", value: "Africa/Dar_es_Salaam"},
        { text: "Ukraine", value: "Europe/Kiev"},
        { text: "Uganda", value: "Africa/Kampala"},
        { text: "United States Minor Outlying Islands", value: "Pacific/Midway", list:
                [
                {text: "Pacific/Midway", value: "UTC +12:37"},
                {text: "Pacific/Wake", value: "UTC +11:06"},
                ]},
        { text: "United States", value: "America/New_York", list:
                [
                {text: "America/Adak", value: "UTC +12:13"},
                {text: "America/Anchorage", value: "UTC +14:00"},
                {text: "America/Boise", value: "UTC -07:44"},
                {text: "America/Chicago", value: "UTC -05:50"},
                {text: "America/Denver", value: "UTC -06:59"},
                {text: "America/Detroit", value: "UTC -05:32"},
                {text: "America/Indiana/Indianapolis", value: "UTC -05:44"},
                {text: "America/Indiana/Knox", value: "UTC -05:46"},
                {text: "America/Indiana/Marengo", value: "UTC -05:45"},
                {text: "America/Indiana/Petersburg", value: "UTC -05:49"},
                {text: "America/Indiana/Tell_City", value: "UTC -05:47"},
                {text: "America/Indiana/Vevay", value: "UTC -05:40"},
                {text: "America/Indiana/Vincennes", value: "UTC -05:50"},
                {text: "America/Indiana/Winamac", value: "UTC -05:46"},
                {text: "America/Juneau", value: "UTC +15:02"},
                {text: "America/Kentucky/Louisville", value: "UTC -05:43"},
                {text: "America/Kentucky/Monticello", value: "UTC -05:39"},
                {text: "America/Los_Angeles", value: "UTC -07:52"},
                {text: "America/Menominee", value: "UTC -05:50"},
                {text: "America/Metlakatla", value: "UTC +15:13"},
                {text: "America/New_York", value: "UTC -04:56"},
                {text: "America/Nome", value: "UTC +12:58"},
                {text: "America/North_Dakota/Beulah", value: "UTC -06:47"},
                {text: "America/North_Dakota/Center", value: "UTC -06:45"},
                {text: "America/North_Dakota/New_Salem", value: "UTC -06:45"},
                {text: "America/Phoenix", value: "UTC -07:28"},
                {text: "America/Sitka", value: "UTC +14:58"},
                {text: "America/Yakutat", value: "UTC +14:41"},
                {text: "Pacific/Honolulu", value: "UTC -10:31"},
                ]},
        { text: "Uruguay", value: "America/Montevideo"},
        { text: "Uzbekistan", value: "Asia/Tashkent", list:
                [
                {text: "Asia/Tashkent", value: "UTC +04:27"},
                {text: "Asia/Samarkand", value: "UTC +04:37"},
                ]},
        { text: "Vatican", value: "Europe/Vatican"},
        { text: "Saint Vincent And The Grenadines", value: "America/St_Vincent"},
        { text: "Venezuela", value: "America/Caracas"},
        { text: "British Virgin Islands", value: "America/Tortola"},
        { text: "U.S. Virgin Islands", value: "America/St_Thomas"},
        { text: "Vietnam", value: "Asia/Taipei"},
        { text: "Vanuatu", value: "Pacific/Efate"},
        { text: "Wallis And Futuna", value: "Pacific/Wallis"},
        { text: "Samoa", value: "Pacific/Apia"},
        { text: "Yemen", value: "Asia/Aden"},
        { text: "Mayotte", value: "Indian/Mayotte"},
        { text: "South Africa", value: "Africa/Johannesburg"},
        { text: "Zambia", value: "Africa/Lusaka"},
        { text: "Zimbabwe", value: "Africa/Harare"},
      ],
       days: [
        {
          text: "menuitems.dashboards.data.settings.sun",
          value: 64,
          isChecked: false,
        },
        {
          text: "menuitems.dashboards.data.settings.mon",
          value: 32,
          isChecked: false,
        },
        {
          text: "menuitems.dashboards.data.settings.tue",
          value: 16,
          isChecked: false,
        },
        {
          text: "menuitems.dashboards.data.settings.wed",
          value: 8,
          isChecked: false,
        },
        {
          text: "menuitems.dashboards.data.settings.thu",
          value: 4,
          isChecked: false,
        },
        {
          text: "menuitems.dashboards.data.settings.fri",
          value: 2,
          isChecked: false,
        },
        {
          text: "menuitems.dashboards.data.settings.sat",
          value: 1,
          isChecked: false,
        },
      ],
      startWorkHr: -1,
      startWorkMin: 0,
      endWorkHr: -1,
      endWorkMin: 0,
      monFri: false,
      monSat: false,
      isInvalidValidDays: true,
      image: "",
      file: "",
    };
  },
  validations: {
    employee: {
      name: {
        required,
      },
      designation: {
        required,
      },
      email: {
        required,
        email,
      },
      alternateEmail: {
        email,
      },
      country: {
        required,
      },
      timezone: {
        required,
      },
    },
    startWorkHr: {
      minValue: minValue(0),
      maxValue: maxValue(23),
    },
    startWorkMin: {
      minValue: minValue(0),
      maxValue: maxValue(60),
    },
    endWorkHr: {
      minValue: minValue(0),
      maxValue: maxValue(24),
    },
    endWorkMin: {
      minValue: minValue(0),
      maxValue: maxValue(60),
    },
  },
  methods: {
    onSelect() {
      if(!this.employee.country.list) {
        if(!this.employee.timezone) {
          this.employee.timezone = {};
        }
        this.employee.timezone.text = this.employee.country.value;
        this.employee.timezone.value = '';
      } else {
        this.employee.timezone = null;
      }
    },
     nameWithLangAndValue({ text, value }) {
      if(value == null && text == null) {
        return ``;
      }
      return `${text}  ( ${value} )`;
    },
    async getAllRules() {
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/rule/get_all", {
          params: { companyId: this.loginData.companyId },
        });
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            for (var i = 0; i < response.data.data.length; i++) {
              var d = {};
              d.value = response.data.data[i].ruleId;
              d.text = response.data.data[i].ruleName;
              this.ruleOptions.push(d);
            }
          }
        }
      } catch (error) {
       // console.log(error);
      }
    },
    async getAllTeams() {
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/team/get_all", {
          params: { companyId: this.loginData.companyId },
        });
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            for (var i = 0; i < response.data.data.length; i++) {
              var d = {};
              d.value = response.data.data[i].teamId;
              d.text = response.data.data[i].teamName;

              this.teamOptions.push(d);
            }
          }
        }
      } catch (error) {
       // console.log(error);
      }
    },
    async getAllProjects() {
      try {
        const response = await axios.get(
          process.env.VUE_APP_EMPLOYEE_URL + "/project/get_all",
          { params: { companyId: this.loginData.companyId } }
        );
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            for (var i = 0; i < response.data.data.length; i++) {
              var d = {};
              d.value = response.data.data[i].projectId;
              d.text = response.data.data[i].projectName;

              this.projectOptions.push(d);
            }
          }
        }
      } catch (error) {
       // console.log(error);
      }
    },
    onAccept(file) {
      this.image = file.name;
      this.file = file;
    },
    nameWithLang({ text }) {
      return `${text}`;
    },
    checkboxFun(val) {
      if (val == "monFri") {
        if (this.monFri == true) {
          this.monSat = false;
          this.days[0].isChecked = false;
          this.days[1].isChecked = true;
          this.days[2].isChecked = true;
          this.days[3].isChecked = true;
          this.days[4].isChecked = true;
          this.days[5].isChecked = true;
          this.days[6].isChecked = false;
        } else {
          this.days[1].isChecked = false;
          this.days[2].isChecked = false;
          this.days[3].isChecked = false;
          this.days[4].isChecked = false;
          this.days[5].isChecked = false;
        }
      } else {
        if (this.monSat == true) {
          this.monFri = false;
          this.days[0].isChecked = false;
          this.days[1].isChecked = true;
          this.days[2].isChecked = true;
          this.days[3].isChecked = true;
          this.days[4].isChecked = true;
          this.days[5].isChecked = true;
          this.days[6].isChecked = true;
        } else {
          this.days[1].isChecked = false;
          this.days[2].isChecked = false;
          this.days[3].isChecked = false;
          this.days[4].isChecked = false;
          this.days[5].isChecked = false;
          this.days[6].isChecked = false;
        }
      }
    },
    validateDays() {
      if (this.monFri == true) {
        return true;
      }
      if (this.monSat == true) {
        return true;
      }

      for (var i = 0; i < this.days.length; i++) {
        if (this.days[i].isChecked == true) {
          return true;
        }
      }
      return false;
    },
    editEmployee() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      this.isInvalidValidDays =
        !this.days[0].isChecked &&
        !this.days[1].isChecked &&
        !this.days[2].isChecked &&
        !this.days[3].isChecked &&
        !this.days[4].isChecked &&
        !this.days[5].isChecked &&
        !this.days[6].isChecked &&
        !this.monFri &&
        !this.monSat;

      this.employee.shiftStartTime =
          parseInt(this.startWorkHr * 60) + parseInt(this.startWorkMin);
        this.employee.shiftEndTime =
          parseInt(this.endWorkHr * 60) + parseInt(this.endWorkMin);

        this.employee.workingDays = 0;
        for (var i = 0; i < this.days.length; i++) {
          if (this.days[i].isChecked == true) {
            this.employee.workingDays += parseInt(this.days[i].value);
          }
        }
      if(this.employee.shiftStartTime >= this.employee.shiftEndTime) {
        this.isInvalidShift = true;
      } else {
        this.isInvalidShift = false;
      }

      if (this.$v.$invalid || this.isInvalidValidDays || this.isInvalidShift) {
        return;
      } else {
        
        let formData = new FormData();
        formData.append("empId", this.employee.empId);
        formData.append("companyId", this.employee.companyId);
        formData.append("empIdInCompany", this.employee.empIdInCompany.trim());
        if(this.employee.team != null){
          formData.append("teamId", this.employee.team.value);
        } else {
          formData.append("teamId", 1000000);
        }
        formData.append("name", this.employee.name.trim());
        formData.append("designation", this.employee.designation.trim());
        formData.append("email", this.employee.email.trim());
        formData.append("alternateEmail", this.employee.alternateEmail.trim());
        formData.append("phone", this.employee.phone.trim());
        /*if(this.employee.isNightShift == true) {
          formData.append("isNightShift", 1);
        } else {
          formData.append("isNightShift", 0);
        }*/
        if(this.employee.gender != null) {
          formData.append("gender", this.employee.gender.value);
        } else {
          formData.append("gender", 0);
        }

        if(this.longDob != null) {
          var date = new Date(this.longDob),
          mnth = ("0" + (date.getMonth() + 1)).slice(-2),
          day = ("0" + date.getDate()).slice(-2);
          date = [date.getFullYear(), mnth, day].join("-");
          formData.append("dob", date);
        } else {
          formData.append("dob", "");
        }
        formData.append("location", this.employee.location.trim());
        
        formData.append("country", this.employee.country.text);  
        if(this.employee.country.list && this.employee.country.list.length > 0) {
          if(this.employee.timezone != null && this.employee.timezone.text != null && this.employee.timezone != '') {
            formData.append("timezone", this.employee.timezone.text);
          } else {
            formData.append("timezone", this.employee.country.value);
          }
        } else {
            formData.append("timezone", this.employee.country.value);
        }

        formData.append("linkedInUrl", this.employee.linkedInUrl.trim());
        if(this.employee.projects != null && this.employee.projects.length > 0){
          formData.append("projects", JSON.stringify(this.employee.projects));
        }
        formData.append("shiftStartTime", this.employee.shiftStartTime);
        formData.append("shiftEndTime", this.employee.shiftEndTime);
        formData.append("workingDays", this.employee.workingDays);

        if(this.employee.joiningDate != null) {
          date = new Date(this.longJoiningDate),
          mnth = ("0" + (date.getMonth() + 1)).slice(-2),
          day = ("0" + date.getDate()).slice(-2);
          date = [date.getFullYear(), mnth, day].join("-");

          formData.append("joiningDate", date);
        } else {
          formData.append("joiningDate", "");
        }
        
        if(this.employee.rule != null){
        formData.append("ruleId", this.employee.rule.value);
        }
        
        axios
          .post(process.env.VUE_APP_EMPLOYEE_URL + `/employee/edit`, formData)
          .then((res) => {
            if(res.data.success == "true") {
              Swal.fire({
                title: "Edited!",
                text: "Employee has been edited.",
                icon: 'success',
                onClose: () => {
                  this.$router.push('/employee/list');
                }
              });
            }
            return res;
          })
          .catch((err) => {

            return err;
          });
      }
    },
  },
  created() {

    if(!this.$route.params.data) {
      this.$router.push('/employee/list');
    }

    this.loginData = JSON.parse(localStorage.getItem('user'));
    this.getAllRules();
    this.getAllTeams();
    //this.getAllProjects();

    this.employeeTest = this.$route.params.data;
  },
  mounted() {
    var c = {};
    c.value = this.employeeTest.teamId;
    c.text = this.employeeTest.teamName;
    this.employeeTest.team = c;

    c = {};
    c.value = this.employeeTest.ruleId;
    c.text = this.employeeTest.ruleName;
    this.employeeTest.rule = c;

    let country = this.employeeTest.country;
    let timezone = this.employeeTest.timezone;

    for(var i = 0;i < this.countryOptions.length;i++) {
      if(this.countryOptions[i].text == country) {
        this.employeeTest.country = this.countryOptions[i];

        if(this.employeeTest.country.list && this.employeeTest.country.list.length > 0) {
          for(var j = 0;j < this.employeeTest.country.list.length;j++) {
            if(this.employeeTest.country.list[j].text == timezone) {
              this.employeeTest.timezone = {};
              this.employeeTest.timezone.text = this.employeeTest.country.list[j].text;
              this.employeeTest.timezone.value = this.employeeTest.country.list[j].value;
              break;
            }
          }
        } else {
          this.employeeTest.timezone = {};
          this.employeeTest.timezone.text = timezone;
          this.employeeTest.timezone.value = '';
        }
        break;
      }
    }

    if(this.employeeTest.gender != 0){
      c = {};
      c.value = this.employeeTest.gender;
      c.text = this.genderOptions[this.employeeTest.gender - 1].text;
      this.employeeTest.gender = c;
    } else {
      this.employeeTest.gender = null;
    }

    if(this.employeeTest.dob != '') {
      this.longDob = new Date(this.employeeTest.dob);
    } else {
      this.longDob = null;
    }

    if(this.employeeTest.joiningDate != null && this.employeeTest.joiningDate != "" && this.employeeTest.joiningDate != 0) {
      this.longJoiningDate = new Date(this.employeeTest.joiningDate);
    }

    this.startWorkHr = parseInt(this.employeeTest.shiftStartTime.split(" : ")[0]);
    this.startWorkMin = parseInt(this.employeeTest.shiftStartTime.split(" : ")[1]);
    this.endWorkHr = parseInt(this.employeeTest.shiftEndTime.split(" : ")[0]);
    this.endWorkMin = parseInt(this.employeeTest.shiftEndTime.split(" : ")[1]);
    
    for(var d = 0;d < 7;d++){
      this.days[d].isChecked = Boolean(this.employeeTest.workingDays & (1 << (6 - d)));
    }
    this.employee = JSON.parse(JSON.stringify(this.employeeTest));
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('menuitems.employee.form.editEmployee')" />
    <form @submit.prevent="editEmployee">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-3">{{ $t('menuitems.employee.basicInformation') }}</h4>

              <div class="row">
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="employeename">{{ $t('menuitems.employee.form.employeeName') }} <i class="mdi mdi-asterisk text-danger font-size-10"></i></label>
                    <input
                      v-model="employee.name"
                      type="text"
                      class="form-control"
                      :class="{
                        'is-invalid': submitted && $v.employee.name.$error,
                      }"
                    />

                    <div
                      v-if="submitted && !$v.employee.name.required"
                      class="invalid-feedback"
                    >
                      {{ $t('menuitems.employee.form.employeeName') }} {{ $t('menuitems.employee.form.isRequired') }}.
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="alternateemail">{{ $t('menuitems.employee.form.alternateEmail') }}</label>
                    <input
                      v-model="employee.alternateEmail"
                      type="text"
                      class="form-control"
                      :class="{
                        'is-invalid':
                          submitted && $v.employee.alternateEmail.$error,
                      }"
                    />
                    <div
                      v-if="submitted && !$v.employee.alternateEmail.email"
                      class="invalid-feedback"
                    >
                      Invalid Email.
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="control-label">{{ $t('menuitems.employee.form.gender') }}</label>
                    <multiselect
                      v-model="employee.gender"
                      :options="genderOptions"
                      :custom-label="nameWithLang"
                      track-by="text"
                    ></multiselect>
                  </div>
                  <div class="mb-3">
                    <label for="location">{{ $t('menuitems.employee.form.location') }}</label>
                    <input
                      id="location"
                      v-model="employee.location"
                      name="name"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="mb-3">
                    <label for="linkedinurl">{{ $t('menuitems.employee.form.timezone') }} <i class="mdi mdi-asterisk text-danger font-size-10"></i></label>
                    <multiselect
                      v-if="employee.country.list && employee.country.list.length > 0"
                      v-model="employee.timezone"
                      :options="employee.country.list"
                      :custom-label="nameWithLangAndValue"
                      :class="{
                        'is-invalid': submitted && $v.employee.timezone.$error,
                      }"
                      track-by="text"
                    ></multiselect>
                    <input
                      v-else
                      type="text"
                      class="form-control"
                      disabled
                      v-model="employee.timezone.text"
                    />
                    <div
                      v-if="submitted && !$v.employee.timezone.required"
                      class="invalid-feedback"
                    >
                      Invalid Timezone.
                    </div>
                  </div>

                  <!--<label>Product Images</label>
                  <vue-dropzone
                    id="dropzone"
                    ref="myVueDropzone"
                    :use-custom-slot="true"
                    :options="dropzoneOptions"
                  >
                    <div class="dropzone-custom-content">
                      <div class="mb-1">
                        <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                      </div>
                      <h4>Drop files here or click to upload.</h4>
                    </div>
                  </vue-dropzone>-->
                </div>

                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="email">{{ $t('menuitems.employee.email') }} <i class="mdi mdi-asterisk text-danger font-size-10"></i></label>
                    <input
                      id="email"
                      v-model="employee.email"
                      name="email"
                      type="text"
                      class="form-control"
                      :class="{
                        'is-invalid': submitted && $v.employee.email.$error,
                      }"
                    />

                    <div
                      v-if="submitted && !$v.employee.email.required"
                      class="invalid-feedback"
                    >
                      {{ $t('menuitems.employee.email') }} {{ $t('menuitems.employee.form.isRequired') }}.
                    </div>
                    <div
                      v-if="submitted && !$v.employee.email.email"
                      class="invalid-feedback"
                    >
                      {{ $t('menuitems.employee.form.invalid') }} {{ $t('menuitems.employee.email') }}.
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="phone">{{ $t('menuitems.employee.form.phone') }}</label>
                    <input
                      id="phone"
                      v-model="employee.phone"
                      name="phone"
                      type="text"
                      class="form-control"
                    />
                  </div>

                  <div class="mb-3">
                    <label for="price">D.O.B.</label>
                    <date-picker
                      v-model="longDob"
                      :first-day-of-week="1"
                      lang="en"
                    ></date-picker>
                  </div>

                  <div class="mb-3">
                    <label class="control-label">{{ $t('menuitems.employee.Country') }} <i class="mdi mdi-asterisk text-danger font-size-10"></i></label>
                    <multiselect
                      v-model="employee.country"
                      @input="onSelect"
                      :options="countryOptions"
                      :class="{
                        'is-invalid': submitted && $v.employee.country.$error,
                      }"
                      :custom-label="nameWithLang"
                      track-by="text"
                    ></multiselect>
                    <div
                      v-if="submitted && !$v.employee.country.required"
                      class="invalid-feedback"
                    >
                      {{ $t('menuitems.employee.Country') }} {{ $t('menuitems.employee.form.isRequired') }}.
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="linkedinurl">{{ $t('menuitems.employee.form.linkedInUrl') }}</label>
                    <input
                      v-model="employee.linkedInUrl"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <!--<div class="mb-3">
                    <label for="productdesc">Comments</label>
                    <textarea
                      id="productdesc"
                      class="form-control"
                      rows="5"
                    ></textarea>
                  </div>-->
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-3">{{ $t('menuitems.employee.form.professionalInformation') }}</h4>

              <div class="row">
                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="employeecode">{{ $t('menuitems.employee.form.employeeCode') }}</label>
                    <input
                      id="employeecode"
                      name="employeecode"
                      v-model="employee.empIdInCompany"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="mb-3">
                    <label for="metakeywords">{{ $t('menuitems.employee.form.team') }}</label>
                    <multiselect
                      v-model="employee.team"
                      :options="teamOptions"
                      :custom-label="nameWithLang"
                      track-by="text"
                    ></multiselect>
                  </div>
                  <div class="mb-3">
                    <label for="rule">{{ $t('menuitems.employee.form.applyRule') }}</label>
                    <multiselect
                      v-model="employee.rule"
                      :options="teamOptions"
                       :custom-label="nameWithLang"
                      track-by="text"
                    ></multiselect>
                  </div>
                  <div class="mb-3">
                    <label for="metatitle">{{ $t('menuitems.employee.form.doj') }}</label>
                    <date-picker
                      v-model="longJoiningDate"
                      :first-day-of-week="1"
                      lang="en"
                    ></date-picker>
                  </div>
                  <!--<div class="mb-3">
                    <label for="projects">Working On</label>
                    <multiselect
                      v-model="employee.projects"
                      :options="projectOptions"
                      :custom-label="nameWithLang"
                      :multiple="true"
                      track-by="text"
                    ></multiselect>
                  </div>-->
                </div>

                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="designation">{{ $t('menuitems.employee.designation') }} <i class="mdi mdi-asterisk text-danger font-size-10"></i></label>
                    <input
                      id="designation"
                      name="designation"
                      v-model="employee.designation"
                      type="text"
                      class="form-control"
                      :class="{
                        'is-invalid':
                          submitted && $v.employee.designation.$error,
                      }"
                    />
                    <div
                      v-if="submitted && !$v.employee.designation.required"
                      class="invalid-feedback"
                    >
                      {{ $t('menuitems.employee.designation') }} {{ $t('menuitems.employee.isRequired.') }}.
                    </div>
                  </div>
                  <!--<div class="mb-3">
                    <label for="metatitle">Date of Joining</label>
                    <date-picker
                      v-model="longJoiningDate"
                      :first-day-of-week="1"
                      lang="en"
                    ></date-picker>
                  </div>-->
                  <div class="mb-1">
                    <label for="metakeywords">{{ $t('menuitems.employee.form.shift') }} <i class="mdi mdi-asterisk text-danger font-size-10"></i></label>
                    <b-row>
                      <b-col md="2">
                        <b-form-select
                          class="form-select mb-3"
                          :class="{
                            'is-invalid': submitted && $v.startWorkHr.$error,
                          }"
                          v-model="startWorkHr"
                          :disabled="false"
                        >
                          <b-form-select-option :value="-1"
                            >Hours...</b-form-select-option
                          >
                          <b-form-select-option value="0"
                            >00</b-form-select-option
                          >
                          <b-form-select-option value="1"
                            >01</b-form-select-option
                          >
                          <b-form-select-option value="2"
                            >02</b-form-select-option
                          >
                          <b-form-select-option value="3"
                            >03</b-form-select-option
                          >
                          <b-form-select-option value="4"
                            >04</b-form-select-option
                          >
                          <b-form-select-option value="5"
                            >05</b-form-select-option
                          >
                          <b-form-select-option value="6"
                            >06</b-form-select-option
                          >
                          <b-form-select-option value="7"
                            >07</b-form-select-option
                          >
                          <b-form-select-option value="8"
                            >08</b-form-select-option
                          >
                          <b-form-select-option value="9"
                            >09</b-form-select-option
                          >
                          <b-form-select-option value="10"
                            >10</b-form-select-option
                          >
                          <b-form-select-option value="11"
                            >11</b-form-select-option
                          >
                          <b-form-select-option value="12"
                            >12</b-form-select-option
                          >
                          <b-form-select-option value="13"
                            >13</b-form-select-option
                          >
                          <b-form-select-option value="14"
                            >14</b-form-select-option
                          >
                          <b-form-select-option value="15"
                            >15</b-form-select-option
                          >
                          <b-form-select-option value="16"
                            >16</b-form-select-option
                          >
                          <b-form-select-option value="17"
                            >17</b-form-select-option
                          >
                          <b-form-select-option value="18"
                            >18</b-form-select-option
                          >
                          <b-form-select-option value="19"
                            >19</b-form-select-option
                          >
                          <b-form-select-option value="20"
                            >20</b-form-select-option
                          >
                          <b-form-select-option value="21"
                            >21</b-form-select-option
                          >
                          <b-form-select-option value="22"
                            >22</b-form-select-option
                          >
                          <b-form-select-option value="23"
                            >23</b-form-select-option
                          >
                        </b-form-select>
                      </b-col>
                      <b-col md="2">
                        <b-form-select
                          class="form-select mb-3"
                          v-model="startWorkMin"
                          :class="{
                            'is-invalid': submitted && $v.startWorkMin.$error,
                          }"
                          :disabled="false"
                        >
                          <b-form-select-option :value="0"
                            >00</b-form-select-option
                          >
                          <b-form-select-option value="5"
                            >05</b-form-select-option
                          >
                          <b-form-select-option value="10"
                            >10</b-form-select-option
                          >
                          <b-form-select-option value="15"
                            >15</b-form-select-option
                          >
                          <b-form-select-option value="20"
                            >20</b-form-select-option
                          >
                          <b-form-select-option value="25"
                            >25</b-form-select-option
                          >
                          <b-form-select-option value="30"
                            >30</b-form-select-option
                          >
                          <b-form-select-option value="35"
                            >35</b-form-select-option
                          >
                          <b-form-select-option value="40"
                            >40</b-form-select-option
                          >
                          <b-form-select-option value="45"
                            >45</b-form-select-option
                          >
                          <b-form-select-option value="50"
                            >50</b-form-select-option
                          >
                          <b-form-select-option value="55"
                            >55</b-form-select-option
                          >
                          <b-form-select-option value="60"
                            >60</b-form-select-option
                          >
                        </b-form-select>
                      </b-col>
                      <b-col md="1"> </b-col>
                      <b-col md="2">
                        <b-form-select
                          class="form-select mb-3"
                          v-model="endWorkHr"
                          :class="{
                            'is-invalid': submitted && $v.endWorkHr.$error,
                          }"
                          :disabled="false"
                        >
                          <b-form-select-option :value="-1"
                            >Hours...</b-form-select-option
                          >
                          <b-form-select-option value="0"
                            >00</b-form-select-option
                          >
                          <b-form-select-option value="1"
                            >01</b-form-select-option
                          >
                          <b-form-select-option value="2"
                            >02</b-form-select-option
                          >
                          <b-form-select-option value="3"
                            >03</b-form-select-option
                          >
                          <b-form-select-option value="4"
                            >04</b-form-select-option
                          >
                          <b-form-select-option value="5"
                            >05</b-form-select-option
                          >
                          <b-form-select-option value="6"
                            >06</b-form-select-option
                          >
                          <b-form-select-option value="7"
                            >07</b-form-select-option
                          >
                          <b-form-select-option value="8"
                            >08</b-form-select-option
                          >
                          <b-form-select-option value="9"
                            >09</b-form-select-option
                          >
                          <b-form-select-option value="10"
                            >10</b-form-select-option
                          >
                          <b-form-select-option value="11"
                            >11</b-form-select-option
                          >
                          <b-form-select-option value="12"
                            >12</b-form-select-option
                          >
                          <b-form-select-option value="13"
                            >13</b-form-select-option
                          >
                          <b-form-select-option value="14"
                            >14</b-form-select-option
                          >
                          <b-form-select-option value="15"
                            >15</b-form-select-option
                          >
                          <b-form-select-option value="16"
                            >16</b-form-select-option
                          >
                          <b-form-select-option value="17"
                            >17</b-form-select-option
                          >
                          <b-form-select-option value="18"
                            >18</b-form-select-option
                          >
                          <b-form-select-option value="19"
                            >19</b-form-select-option
                          >
                          <b-form-select-option value="20"
                            >20</b-form-select-option
                          >
                          <b-form-select-option value="21"
                            >21</b-form-select-option
                          >
                          <b-form-select-option value="22"
                            >22</b-form-select-option
                          >
                          <b-form-select-option value="23"
                            >23</b-form-select-option
                          >
                        </b-form-select>
                      </b-col>
                      <b-col md="2">
                        <b-form-select
                          class="form-select mb-3"
                          v-model="endWorkMin"
                          :class="{
                            'is-invalid': submitted && $v.endWorkMin.$error,
                          }"
                          :disabled="false"
                        >
                          <b-form-select-option :value="0"
                            >00</b-form-select-option
                          >
                          <b-form-select-option value="5"
                            >05</b-form-select-option
                          >
                          <b-form-select-option value="10"
                            >10</b-form-select-option
                          >
                          <b-form-select-option value="15"
                            >15</b-form-select-option
                          >
                          <b-form-select-option value="20"
                            >20</b-form-select-option
                          >
                          <b-form-select-option value="25"
                            >25</b-form-select-option
                          >
                          <b-form-select-option value="30"
                            >30</b-form-select-option
                          >
                          <b-form-select-option value="35"
                            >35</b-form-select-option
                          >
                          <b-form-select-option value="40"
                            >40</b-form-select-option
                          >
                          <b-form-select-option value="45"
                            >45</b-form-select-option
                          >
                          <b-form-select-option value="50"
                            >50</b-form-select-option
                          >
                          <b-form-select-option value="55"
                            >55</b-form-select-option
                          >
                          <b-form-select-option value="60"
                            >60</b-form-select-option
                          >
                        </b-form-select>
                      </b-col>
                      <!--<b-col md="3">
                        <b-form-checkbox
                          v-model="employee.isNightShift"
                          class="mb-3"
                          checked
                          plain
                          validated
                          >Night Shift</b-form-checkbox
                        >
                      </b-col>-->
                      <b-col md="2">
                        <b-form-checkbox
                          v-model="monFri"
                          class="mb-3"
                          @change="checkboxFun('monFri')"
                          checked
                          plain
                          validated
                          >{{ $t('menuitems.dashboards.data.settings.mon') }}-{{ $t('menuitems.dashboards.data.settings.fri') }}</b-form-checkbox
                        >
                      </b-col>
                      <b-col md="2">
                        <b-form-checkbox
                          v-model="monSat"
                          @change="checkboxFun('monSat')"
                          class="mb-3"
                          checked
                          plain
                          >{{ $t('menuitems.dashboards.data.settings.mon') }}-{{ $t('menuitems.dashboards.data.settings.sat') }}</b-form-checkbox
                        >
                      </b-col>
                      <b-col
                        v-for="(item, index) in days"
                        :key="item.text"
                        md="2"
                      >
                        <b-form-checkbox
                          v-model="days[index].isChecked"
                          class="mb-3"
                          checked
                          plain
                          >{{ $t(item.text) }}</b-form-checkbox
                        >
                      </b-col>

                      <span
                        v-if="submitted && !days[0].isChecked && !days[1].isChecked && !days[2].isChecked && !days[3].isChecked && !days[4].isChecked && !days[5].isChecked && !days[6].isChecked && !monFri && !monSat"
                        class="text-danger"
                        >{{ $t('menuitems.employee.form.shift') }} {{ $t('menuitems.employee.form.isRequired') }}.</span
                      >
                      <span
                        v-if="isInvalidShift"
                        class="text-danger"
                        >{{ $t('menuitems.employee.form.shiftStartErr') }}.</span
                      >
                    </b-row>
                  </div>

                  <!--<div class="mb-3">
                    <label for="remarks">Remarks</label>
                    <input
                      id="remarks"
                      name="remarks"
                      v-model="employee.remarks"
                      type="text"
                      class="form-control"
                    />
                  </div>-->
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-sm-10"></div>
            <div class="col-sm-2">
              <!--<button type="submit" class="btn btn-secondary btn-lg">
                Cancel
              </button>-->
              <button type="submit" class="btn btn-primary btn-lg ms-2">
                {{ $t('menuitems.employee.save') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- end row -->
  </Layout>
</template>
